export const i18nKeyPrefix = 'MAIN-TOUR'
